import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const ParentCompanyPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.ParentCompany}
        fetchRecordsUrl={AdminReqUrls.admin__parentComp__mainPage_fetch_recordList}
    />)
});
export default ParentCompanyPage;
